import * as React from "react";
import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import { useNavigate, useLocation } from "react-router-dom";
import DownArrowIcon from "./images/arrowdown.svg";

//styles
import { LanguagesTooltip, ShowFlags, CurrentLanguage } from "./styles";
import { Icon } from "./styles";

import { tooltipClasses } from "@mui/material/Tooltip";

//data
import { languagesToChoose } from "./data";
import { FlexLayout } from "shared/globalStyles";

interface IProps {
  showLabel?: boolean;
}
interface IlanguagesToChoose {
  language: string;
  label: string;
}
type IlanguageObj = Record<string, IlanguagesToChoose>;

const ChooseLanguage = ({ showLabel = false }: IProps) => {
  const { i18n } = useTranslation("global");
  const { language } = i18n;
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Add a ref to detect clicks outside
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const changeLanguage = (value: string) => {
    i18n.changeLanguage(value);
    location.search = `${value}`;
    navigate({
      search: location.search,
    });
    // Close the tooltip when language is changed
    setOpen(false);
  };

  const languageObj: IlanguageObj = languagesToChoose.reduce(
    (acc, item) => ({ ...acc, [item.language]: item }),
    {},
  );

  // Toggle open state on button click
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  // Close when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        anchorRef.current &&
        !anchorRef.current.contains(event.target as Node) &&
        !(event.target as Element).closest(`.${tooltipClasses.tooltip}`)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const currentLanguage = languageObj[language]?.label;

  return (
    <LanguagesTooltip
      placement="bottom"
      open={open}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      slotProps={{
        popper: {
          disablePortal: true,
        },
      }}
      title={
        <FlexLayout flexDirection="column">
          {languagesToChoose.map((item) => (
            <React.Fragment key={item.language}>
              <IconButton
                sx={{
                  borderRadius: 0,
                  "&:hover": { backgroundColor: "transparent" },
                }}
                onClick={() => changeLanguage(item.language)}
              >
                <CurrentLanguage>{item.label} </CurrentLanguage>
              </IconButton>
            </React.Fragment>
          ))}
        </FlexLayout>
      }
    >
      <ShowFlags size="large" onClick={handleToggle} ref={anchorRef}>
        {showLabel && <CurrentLanguage>{currentLanguage}</CurrentLanguage>}
        <Icon icon={DownArrowIcon} />
      </ShowFlags>
    </LanguagesTooltip>
  );
};
export default ChooseLanguage;
